/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadsStatusResponse
 */
export interface UploadsStatusResponse {
    /**
     * 
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UploadsStatusResponse interface.
 */
export function instanceOfUploadsStatusResponse(value: object): value is UploadsStatusResponse {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UploadsStatusResponseFromJSON(json: any): UploadsStatusResponse {
    return UploadsStatusResponseFromJSONTyped(json, false);
}

export function UploadsStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadsStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function UploadsStatusResponseToJSON(json: any): UploadsStatusResponse {
    return UploadsStatusResponseToJSONTyped(json, false);
}

export function UploadsStatusResponseToJSONTyped(value?: UploadsStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

